// Chat palette + typography tokens.
//
// These intentionally resolve through Studio semantic CSS variables rather
// than fixed concept colors. Generated app themes are sandboxed away from the
// Studio shell, but chat cards still need to follow the active Studio theme
// (light/dark, brand accent, status tokens) instead of hard-coded purple/ink.
//
// See memory references:
//   - reference_concept2_chat_vs_a3_3_diff.md (diff table + token map)
//   - feedback_no_emoji.md / feedback_no_emoji_icons.md (no emoji rule)

// Semantic surfaces.
export const INK_50 = 'hsl(var(--background))'
export const INK_100 = 'hsl(var(--muted))'
export const INK_200 = 'hsl(var(--border))'
export const INK_300 = 'hsl(var(--border))'
export const INK_400 = 'hsl(var(--muted-foreground))'
export const INK_500 = 'hsl(var(--muted-foreground))'
export const INK_600 = 'hsl(var(--foreground))'
export const INK_700 = 'hsl(var(--foreground))'
export const INK = 'hsl(var(--foreground))'
export const MUTED_TEXT = 'hsl(var(--muted-foreground))'
export const SUBTLE_BG = 'hsl(var(--background) / 0.72)'
export const SOFT_BG = 'hsl(var(--muted) / 0.62)'
export const ASSISTANT_ICON_BG = 'hsl(var(--muted) / 0.72)'
export const ASSISTANT_ICON_BORDER = 'hsl(var(--border))'

// Brand accent.
export const PURPLE = 'hsl(var(--primary))'
export const PURPLE_50 = 'hsl(var(--primary) / 0.08)'
export const PURPLE_100 = 'hsl(var(--primary) / 0.12)'
export const PURPLE_700 = 'hsl(var(--primary))'

// Status semantics.
export const OK = 'hsl(var(--success))'
export const WARN = 'hsl(var(--warn))'
export const DANGER = 'hsl(var(--danger))'

// Typography. cogo-studio root layout already loads Inter; mono used for
// metadata/code-like labels (latency, page-percent).
export const FONT_MONO = '"JetBrains Mono", "Geist Mono", monospace'

// Chat surface dimensions.
export const CHAT_RADIUS = 12
export const BUBBLE_RADIUS = 14
export const BUBBLE_TAIL_RADIUS = 4
